import { render, staticRenderFns } from "./DemoAccountDetails.vue?vue&type=template&id=6b69c786&scoped=true"
import script from "./DemoAccountDetails.vue?vue&type=script&lang=js"
export * from "./DemoAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./DemoAccountDetails.vue?vue&type=style&index=0&id=6b69c786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b69c786",
  null
  
)

export default component.exports